import React from "react";
import Box from "@mui/material/Box";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
function CollectionGrid() {
  const itemData = [
    {
      img: "./Assets/collection_1.png",
    },
    {
      img: "./Assets/collection_5.png",
    },
    {
      img: "./Assets/collection_6.png",
    },
    {
      img: "./Assets/collection_2.png",
    },

    {
      img: "./Assets/collection_7.png",
    },
    {
      img: "./Assets/collection_3.png",
    },
    {
      img: "./Assets/collection_8.png",
    },
    {
      img: "./Assets/collection_9.png",
    },
    {
      img: "./Assets/collection_4.png",
    },
  ];
  return (
    <div>
      <Box>
        <ImageList variant="masonry" cols={4} gap={13}>
          {itemData.map((item) => (
            <ImageListItem key={item.img}>
              <img
                className="collection_gal_img"
                src={`${item.img}?w=218&fit=crop&auto=format`}
                srcSet={`${item.img}?w=248&fit=crop=format&dpr=4 4x`}
                alt={item.title}
                loading="lazy"
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
    </div>
  );
}

export default CollectionGrid;
